import z from "zod";

import type { Coupon, PaymentOrigin } from "@/shared/domains";
import { Price } from "@/shared/domains";
import { parseResponseData, publicAPI } from "@/shared/lib";

interface ValidateCouponCodeParams {
  couponCode: Coupon["code"];
  pricesIds: Price["id"][];
  source?: PaymentOrigin;
}

const checkoutDiscountSchema = z.object({
  isValid: z.boolean(),
  code: z.string(),
  get prices() {
    return Price.array();
  },
  total: z.number(),
  totalDiscount: z.number(),
  totalAfterDiscount: z.number(),
});
export type CheckoutDiscount = z.infer<typeof checkoutDiscountSchema>;

export const validateCouponCode = async (params: ValidateCouponCodeParams) => {
  const response = await publicAPI.post("/validate-coupon-code", params);

  return parseResponseData(response, checkoutDiscountSchema);
};
